import dataService from "../../api";
import { startLoading, stopLoading, serverErrorMessage, showNotification, showAlert, catchHandler } from "../../utils/helpers";
import { status } from "../../utils/common";

const state = {
    universities: [],
    university: {},
    totalItems:0,

};

const getters = {
    index: state => universityId => state.universities.findIndex(i => i.universityId === universityId)
};

const mutations = {
    setUniversities: (state, r) => (state.universities = r),
    setTotalItems: (state, r) => (state.totalItems = r),

    add: (state, r) => state.universities.unshift(r),
    delete: (state, index) => state.universities.splice(index, 1),
    lock: (state, index) => state.universities[index].status = status.locked,
    unlock: (state, index) => state.universities[index].status = status.active,
    setUniversity: (state, r) => (state.university = r),
    edit: (state, { index, r }) => state.universities.splice(index, 1, r),

};

const actions = {
    async getAll({ commit },params) {
        try {
            const paramsString = Object.entries(params)
            .filter(([, val]) => val !== null)
            .map(([key, val]) => `${key}=${val}`)
            .join("&");
            startLoading()
            const response = await dataService.universities.getAll(paramsString);
            stopLoading()

            if (!response.data.statusCode) {
               showAlert(serverErrorMessage);
               return;
            }

            commit("setUniversities", response.data.universities);
            commit("setTotalItems", response.data.totalItems);

          
        } catch (error) {
            stopLoading()
            catchHandler(error);
        }
    },
    async add({ commit }, payload) {
        try {
            startLoading()
            const response = await dataService.universities.add(payload);
            stopLoading()

            if (!response.data.statusCode) {
               showAlert(serverErrorMessage);
               return;
            }

            showNotification(response.data.message);
            commit("add", response.data.university);


        } catch (error) {
            stopLoading()
            catchHandler(error);
            return Promise.reject(error);
        }
    },
    async delete({ commit, getters }, id) {
        try {
            startLoading()
            const response = await dataService.universities.delete(id);
            stopLoading()

            if (!response.data.statusCode) {
               showAlert(serverErrorMessage);
               return;
            }

            showNotification(response.data.message);


            const index = getters.index(id);
            commit("delete", index);
        } catch (error) {
            stopLoading()
            catchHandler(error);
        }
    },
    async lock({ commit, getters }, id) {
        try {
            startLoading()
            const response = await dataService.universities.lock(id);
            stopLoading()

            if (!response.data.statusCode) {
               showAlert(serverErrorMessage);
               return;
            }

            showNotification(response.data.message);


            const index = getters.index(id);
            commit("lock", index);
        } catch (error) {
            stopLoading()
            catchHandler(error);
        }
    },
    async unlock({ commit, getters }, id) {
        try {
            startLoading()
            const response = await dataService.universities.unlock(id);
            stopLoading()

            if (!response.data.statusCode) {
               showAlert(serverErrorMessage);
               return;
            }

            showNotification(response.data.message);

            const index = getters.index(id);
            commit("unlock", index);
        } catch (error) {
            stopLoading()
            catchHandler(error);
        }
    },
    async getDetails({ commit }, id) {
        try {
            commit("setUniversity", {});
            console.log(id)
            startLoading()
            const response = await dataService.universities.getDetails(id);
            stopLoading()

            if (!response.data.statusCode) {
               showAlert(serverErrorMessage);
               return;
            }

            commit("setUniversity", response.data.university);
          
        } catch (error) {
            stopLoading()
            catchHandler(error);
        }
    },
    async getForEdit(_, id) {
        try {
            startLoading()
            const response = await dataService.universities.getForEdit(id);
            stopLoading()

            if (!response.data.statusCode) {
               showAlert(serverErrorMessage);
               return;
            }

            return Promise.resolve(response.data.university);
          
        } catch (error) {
            stopLoading()
            catchHandler(error);
        }
    },
    async edit({ commit, getters }, { id, payload }) {
        try {
            startLoading()
            const response = await dataService.universities.edit(id, payload);
            stopLoading()

            if (!response.data.statusCode) {
               showAlert(serverErrorMessage);
               return;
            }


            const index = getters.index(id);
            console.log(index);
            console.log(response.data.university );
            commit("edit", { index, r: response.data.university });

            return Promise.resolve()
        } catch (error) {
            stopLoading()
            catchHandler(error);
            return Promise.reject(error);
        }
    },
};

export default {
    namespaced: true,
    state,
    getters,
    mutations,
    actions
};
